import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StatisticsWrapper } from './styles';
import { StatisticTable } from './components';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const SubscriptionsStatistics: FC = () => {
  const { t } = useTranslation();
  const { isExpiredSoon, isBlocked } = useSubscription();

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <StatisticsWrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <div>
        <h1>{t('subscriptions_statistics.title')}</h1>
      </div>
      <StatisticTable />
    </StatisticsWrapper>
  );
};

export default SubscriptionsStatistics;
